import {
  INIT_SUCCESS,
  INIT_FAIL,
  SEARCH_SUCCESS,
  SEARCH_FAIL,
  PRINTING_SUCCESS,
  PRINTING_FAIL,
  PRINTING_RESET
} from "../actions/printing";

const initialState = {
  rows: [],
  printTarget: [],
  evaluationList: [],
  evaluationTerm: [],
  downloadLink: null,
};

const printing = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT_SUCCESS:
      return {
        ...state,
        evaluationList: payload.evaluationList,
        evaluationTerm: payload.evaluationTerm,
        printTarget: payload.printTarget
      };
    case INIT_FAIL:
      return {
        ...state,
        message: payload
      };
    case SEARCH_SUCCESS:
      return {
        ...state,
        rows: payload.rows
      };
    case SEARCH_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case PRINTING_SUCCESS:
      return {
        ...state,
        downloadLink: payload.downloadLink
      };
    case PRINTING_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case PRINTING_RESET:
      return {
        ...state,
        downloadLink: null
      }  
    default:
      return {
        ...state
      };
  }
};

export default printing;
